var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralsaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19052_51227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 0H0V116H116V0Z",
    fill: "#445689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 87.4531C68.0102 87.4531 76.125 79.3383 76.125 69.3281C76.125 59.318 68.0102 51.2031 58 51.2031C47.9898 51.2031 39.875 59.318 39.875 69.3281C39.875 79.3383 47.9898 87.4531 58 87.4531Z",
    fill: "#445689"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5547,
    cy: 49,
    r: 11,
    fill: "#D0F19A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2218 74.0573L34.7773 59.3906C37.2218 56.9458 37.2218 55.523 42.1107 54.1186C46.3867 52.8902 50.6662 56.827 55.5551 61.1048C60.444 65.3825 64.7218 64.1603 67.7773 64.1603C70.2218 64.1603 71.2403 66.6048 71.444 67.827L87.3329 61.1048C89.238 61.9212 89.7164 63.4068 89.5905 64.8447C89.4061 66.9504 87.7881 68.5745 86.186 69.9533C76.7226 78.0983 65.0445 84.2789 61.6662 83.7159C58.7329 83.227 43.7403 77.1128 37.2218 74.0573Z",
    fill: "#7499D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.444 67.827L87.3329 61.1048C89.238 61.9212 89.7164 63.4068 89.5905 64.8447C89.4061 66.9504 87.7881 68.5745 86.186 69.9533C76.7226 78.0983 65.0445 84.2789 61.6662 83.7159C58.7329 83.227 43.7403 77.1128 37.2218 74.0573L34.7773 59.3906C37.2218 56.9458 37.2218 55.523 42.1107 54.1186C46.3867 52.8902 50.6662 56.827 55.5551 61.1048C60.444 65.3825 64.7218 64.1603 67.7773 64.1603C70.2218 64.1603 71.2403 66.6048 71.444 67.827ZM71.444 67.827C70.9259 68.9926 68.9914 70.8006 66.1432 71.7116C62.4883 72.8805 58.4622 72.3267 54.7295 71.4367C52.7845 70.973 50.8516 70.2222 49.444 69.0492",
    stroke: "#445689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.686 80.5898C29.1292 80.6942 28.5969 80.3156 28.5128 79.7553L25.1413 57.2786C25.0622 56.751 25.4111 56.2543 25.9341 56.1497L33.1621 54.7041C33.7129 54.5939 34.2464 54.9589 34.3433 55.5123L38.2741 77.9744C38.3685 78.5138 38.0116 79.0288 37.4734 79.1297L29.686 80.5898Z",
    fill: "#D0F19A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4582 53.2466C65.7557 53.2466 65.2187 53.0575 64.8473 52.6792C64.4758 52.2942 64.29 51.7404 64.29 51.0176V49.6093C64.9249 49.6093 65.4315 49.5925 65.8098 49.5587C66.188 49.5249 66.4683 49.4506 66.6507 49.3358C66.8398 49.2142 66.9614 49.0386 67.0154 48.8089C67.0762 48.5793 67.1066 48.2652 67.1066 47.8667V46.4888H68.2413V47.8566C68.2413 48.3091 68.1941 48.6975 68.0995 49.0217C68.0117 49.3459 67.8597 49.6127 67.6436 49.8221C67.4274 50.0315 67.137 50.1868 66.7723 50.2882C66.4143 50.3827 65.9685 50.43 65.4349 50.43V51.1291C65.4349 51.4803 65.5092 51.7674 65.6578 51.9903C65.8064 52.2064 66.0698 52.3145 66.448 52.3145C66.7925 52.3145 67.0391 52.2132 67.1876 52.0105C67.343 51.8079 67.4207 51.5242 67.4207 51.1595H68.5554C68.5351 51.8282 68.346 52.3449 67.988 52.7096C67.6368 53.0676 67.1269 53.2466 66.4582 53.2466ZM63.9557 48.5962V47.8059H69.3862V48.5962H63.9557ZM63.9557 46.8738V46.0329H69.3862V46.8738H63.9557Z",
    fill: "#445689"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19052_51227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralsaving);
export default __webpack_public_path__ + "static/media/General saving.2af0524f8037e4fa5cbf9c5cfcb6480e.svg";
export { ForwardRef as ReactComponent };